(() => {
  if (window.sbStoryLoaded) return;
  window.sbStoryLoaded = true;
  const instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const links = [...root.querySelectorAll('.spark-play__contents a')];
    const pairs = links.map(link => [link, document.getElementById(link.hash.slice(1))]).filter(pair => pair[1] && root.contains(pair[1]));
    pairs[0]?.[0].setAttribute('aria-current', 'location');
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      const entry = entries.find(item => item.isIntersecting);
      if (entry) pairs.forEach(([link, target]) => target === entry.target ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
    }, {rootMargin:'-15% 0px -60% 0px'}) : null;
    pairs.forEach(([, target]) => observer?.observe(target));
    const progress = root.querySelector('.spark-play__progress');
    const reading = root.querySelector('.spark-play__reading');
    const end = root.querySelector('.spark-play__activity') || root.querySelector('.spark-play__prose');
    let frame = 0;
    const update = () => {
      frame = 0;
      if (!progress || !reading || !end) return;
      const start = reading.getBoundingClientRect().top + window.scrollY;
      const finish = end.getBoundingClientRect().bottom + window.scrollY;
      const value = Math.min(1,Math.max(0,(window.scrollY-start)/Math.max(1,finish-start-window.innerHeight)));
      progress.style.setProperty('--reading-progress',value);
      progress.setAttribute('aria-valuenow',Math.round(value*100));
    };
    const schedule = () => { if (!controller.signal.aborted && !frame) frame=requestAnimationFrame(update); };
    ['scroll','resize','load'].forEach(type => window.addEventListener(type,schedule,{passive:true,signal:controller.signal}));
    const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    resize?.observe(root);
    document.fonts?.ready.then(schedule);
    schedule();
    instances.set(root, () => {controller.abort();observer?.disconnect();resize?.disconnect();cancelAnimationFrame(frame);instances.delete(root);});
  }
  const scan = scope => {if(scope.matches?.('[data-sb-story]')) init(scope);scope.querySelectorAll('[data-sb-story]').forEach(init);};
  scan(document);
  document.addEventListener('shopify:section:load',event => scan(event.target));
  document.addEventListener('shopify:section:unload',event => {for(const [root,dispose] of instances) if(event.target.contains(root)) dispose();});
})();
